import { InputAdornment, TextField, ToggleButton, ToggleButtonGroup } from "@mui/material";
import React, { useEffect, useState } from "react";
import './index.scss';


interface IContractReferenceInputProps {
    id: string | undefined,
    value: string | null | undefined,
    onChange?: (value: string) => void,
    onBlur?: () => void,
    disabled?: boolean
}

export const ContractReferenceInput: React.FC<IContractReferenceInputProps> = ({
    id,
    value,
    onChange,
    onBlur,
    disabled,
    ...props
}) => {

    useEffect(() => {



        if (value && value !== contractReference) {
            setContractReference(value);
            if (/^\d{7}$/.test(value)) //is it a 7 digit number?
                setReferenceType("Lease");
            else if (value.startsWith("77-FSA-")) {
                if (value.endsWith("-XXX"))
                    setReferenceType("Framework");
            }
            else setReferenceType("SMA");
        }
    }, [value])

    const [referenceType, setReferenceType] = useState<string>("Contract");
    const [contractReference, setContractReference] = useState("");

    const getReferencePlaceholder = () => {
        switch (referenceType.toLowerCase()) {
            case "contract":
                return "77-FSA-___-___";
            case "framework":
                return "77-FSA-___-XXX";
            case "sma":
                return "77-___-___-___";
            case "lease":
                return "_______";
            default: return;
        }
    }

    const getReferencePattern = () => {
        switch (referenceType.toLowerCase()) {
            case "contract":
                return /77-FSA-[0-9][0-9][0-9]-[0-9][0-9][0-9]/;
            case "framework":
                return /77-FSA-[0-9][0-9][0-9]-XXX/;
            case "lease":
                return /^\d{7}$/;
            default:
                return /77-[a-zA-Z0-9][a-zA-Z0-9][a-zA-Z0-9]-[0-9][0-9][0-9]-[0-9][0-9][0-9]/;
        }
    }

    const getHelperText = () => {

        if (contractReference.length === 0) return "Select a reference format and enter the reference number";

        return isValidState() ? `Reference for ${referenceType}  is valid ✓` : `the format for ${referenceType} must be '${getReferencePlaceholder()}'`
    }

    const isValidState = () => {

        if (contractReference.length === 0) return true;

        let regex = new RegExp(getReferencePattern(), 'i');

        return regex.test(contractReference);
    }


    const handleChangeInput = (e: any) => {

        e.currentTarget.value = e.currentTarget.value.toUpperCase();

        setContractReference(e.currentTarget.value);

        if (onChange) onChange(e);
    }

    return (
        <div id="contractreference-input-wrapper">
            <TextField
                id={id}
                value={contractReference}
                disabled={disabled}
                onChange={handleChangeInput}
                onBlur={onBlur}
                label="Reference"
                helperText={getHelperText()}
                placeholder={getReferencePlaceholder()}
                error={!isValidState()}
                required
                inputProps={{
                    pattern: getReferencePattern().toString().replace(/\//g, "")
                }}
                InputProps={{
                    startAdornment: <InputAdornment position="start">
                        <ToggleButtonGroup
                            color="primary"
                            value={referenceType}
                            exclusive
                            onChange={(e: React.MouseEvent<HTMLElement>, refType: string) => { refType && setReferenceType(refType) }}
                            disabled={disabled}
                        >
                            {(!disabled || referenceType === "Contract") && <ToggleButton value="Contract" >Contract</ToggleButton>}
                            {(!disabled || referenceType === "Framework") && <ToggleButton value="Framework" >Framework</ToggleButton>}
                            {(!disabled || referenceType === "SMA") && <ToggleButton value="SMA">SMA</ToggleButton>}
                            {(!disabled || referenceType === "Lease") && <ToggleButton value="Lease">Lease</ToggleButton>}
                        </ToggleButtonGroup>
                    </InputAdornment>
                }}
            />
        </div>
    );
}